import Swal from 'sweetalert2'
import {
    IS_LOADING_CREATE_TYPE_OF_LANDING,
    CREATE_TYPE_OF_LANDING,
    IS_LOADING_LANDINGS,
    LIST_OF_LANDING,
    DATA_OF_LANDING,
    DELETE_LANDING,DEFAULT_LANDING,
    IS_LOADING_CREATE_POINT_PACKAGE,
    CREATE_POINT_PACKAGE,EDIT_POINT_PACKAGE,
    IS_LOADING_POINT_PACKAGES,
    LIST_OF_POINT_PACKAGES,
    DELETE_POINT_PACKAGE,
    GET_POINT_PACKAGE_INFO,
    EDIT_TYPE_OF_LANDING
} from './types'
import {
    urlServer
} from '../../config/GlobalConstant'
import inMemoryJWT from '../../auth/inMemoryJwt';


//Landing management
export const createLanding = (formData, history) => async dispatch => {
    
    console.log()
    for (var pair of formData.entries()) {
        console.log(); 
    }
    
    
    await fetch(`${urlServer}api/landings/create`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                //'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: formData
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
           
            if(respJson.success===true){
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_LANDINGS
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: CREATE_TYPE_OF_LANDING,
                    payload: respJson.data
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const seeLandings = () => async dispatch => {
    console.log()
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_LANDINGS
    });
    
    await fetch(`${urlServer}api/landings/get-all-landings`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: LIST_OF_LANDING,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })
}

export const getLanding = (id) => async dispatch => {

    await fetch(`${urlServer}api/landings/get-landing-id`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                landingID: id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: DATA_OF_LANDING,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })
}

export const updateLanding = (landingUpdated, history, index) => async dispatch => {
     
    await fetch(`${urlServer}api/landings/update-landing`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                //'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: landingUpdated
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_LANDINGS
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: EDIT_TYPE_OF_LANDING,
                    payload: {
                        index: index,
                        data: respJson.data
                    }
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const deleteLanding = (id, index) => async dispatch => {
    

    await fetch(`${urlServer}api/landings/remove-landing`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                landingID: id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: IS_LOADING_LANDINGS
            });
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: DELETE_LANDING,
                payload: index
            });

        })
        .catch(error => {
            console.log()
        })
}

export const getDefaultLanding = () => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_LANDINGS
    });

    await fetch(`${urlServer}api/landings/get-landing-default`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: DEFAULT_LANDING,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })
}

//Points-Package management

export const createPointPackage = (pointPackage, history) => async dispatch => {
    
    
    await fetch(`${urlServer}adminpointpackages/create`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify(pointPackage)
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
           
            if(respJson.success===true){
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_POINT_PACKAGES
                });
                
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: CREATE_POINT_PACKAGE,
                    payload: respJson.data
                });
            }

        })
        .catch(error => {
            console.log()
        })
}
export const seePointPackages = () => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_POINT_PACKAGES
    });
    
    await fetch(`${urlServer}adminpointpackages/get-all`, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: LIST_OF_POINT_PACKAGES,
                payload: respJson.data || []
            });

        })
        .catch(error => {
            console.log()
        })
}

export const deletePointPackage = (id, index) => async dispatch => {
  

    await fetch(`${urlServer}adminpointpackages/delete-id`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                id: id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if(respJson.success===true){
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: IS_LOADING_POINT_PACKAGES
            });
            
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: DELETE_POINT_PACKAGE,
                payload: index
            });
        }
        })
        .catch(error => {
            console.log()
        })
}

export const deactivatePointPackage = (id, index) => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_POINT_PACKAGES
    });
    
    await fetch(`${urlServer}api/point-package/deactivate-id`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                id: id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: DELETE_POINT_PACKAGE,
                payload: index
            });

        })
        .catch(error => {
            console.log()
        })
}

export const getPointPackage = (id) => async dispatch => {

    await fetch(`${urlServer}api/point-package/get-id`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                id: id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_POINT_PACKAGE_INFO,
                payload: respJson.data[0]
            });

        })
        .catch(error => {
            console.log()
        })
}

export const editPointPackage = (poinPackageUpdated, history,index) => async dispatch => {

    await fetch(`${urlServer}adminpointpackages/update`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify(poinPackageUpdated)
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                if (respJson.success === true) {
                    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                        type: IS_LOADING_POINT_PACKAGES
                    });
                    
                    dispatch({ 
                        type: EDIT_POINT_PACKAGE,
                        payload:{data:respJson.data, index:index}
                    });
                }
            }

        })
        .catch(error => {
            console.log()
        })
}

export const deactivateAllPointPackage = () => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_POINT_PACKAGES
    });
    
    await fetch(`${urlServer}api/point-package/getall-deactivate`, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()

            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: LIST_OF_POINT_PACKAGES,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}
